import { ReactElement } from 'react';
import UserInterface from 'interface/user';
import AuthenticatedLayout from './authenticated-layout';

interface LayoutProps {
  children: ReactElement;
  user?: UserInterface | null;
}

export const Layout = ({ children, user }: LayoutProps) => {
  const location = window.location.pathname;

  if (
    location.includes('/login/') ||
    location.includes('onesignin') ||
    location.includes('reset-password') ||
    location.includes('external-login')
  )
    return children;

  return <AuthenticatedLayout user={user}> {children} </AuthenticatedLayout>;
};
